// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// ✅ Debugging Message (After Imports)
console.log("✅ Firebase Config Loading...");

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjRylaPvrSWUjMD7fX5ekG0XFmpmbRizo",
  authDomain: "tour-42758.firebaseapp.com",
  projectId: "tour-42758",
  storageBucket: "tour-42758.appspot.com",
  messagingSenderId: "1057554859449",
  appId: "1:1057554859449:web:41e6d23c38f0ad31432268",
  measurementId: "G-WR0SFF2G38"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log("✅ Firebase Initialized:", app);

// ✅ Only Export Firebase Auth (For Login)
export const auth = getAuth(app);
